import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ManualHeroComponent } from '../manual-hero/manual-hero.component';

@Component({
  selector: 'app-manual-home',
  standalone: true,
  imports: [CommonModule, RouterLink, ManualHeroComponent],
  templateUrl: './manual-home.component.html',
  styleUrl: './manual-home.component.css',
})
export class ManualHomeComponent {}
